// export const baseurl='http://localhost:5000'
// export const baseurl = 'http://13.205.147.130:5001'
export const baseurl = 'https://mensaindia.org/api'
// Energia proctoring API (signup-and-book, hall-ticket-link)
// Same-origin path: proxied to https://procapi.energiasoi.com (no CORS headers upstream)
// by src/setupProxy.js in dev and by nginx.conf in production.
export const caturl = '/energia'
export const payuredircturl='https://mensaindia.org/api/candidate/payment/audit'
const PRODUCTION_LINK = "https://secure.payu.in/_payment";
const SANDBOX_LINK = "https://test.payu.in/_payment";
var production = true;
export const payuurl = production ? PRODUCTION_LINK : SANDBOX_LINK;